import axios from 'axios';

const eAlertsCoreAPI = process.env.REACT_APP_EALERTS_CORE_API_URL;
const token = localStorage.getItem('token');
export const ENDPOINTS = {
  ACCOUNT: 'Account',
  SENDEMAIL: 'SendEmail',
  SUBSCRIPTION: 'Subscription',
  PARCEL: 'Parcel',
  ALERT: 'Alert',
};

// Formats an 11-digit parcel number as XXX-XXXXXX-XX, stripping any existing hyphens first.
export function formatParcelNumber(parcel) {
  if (!parcel) return parcel;
  const digits = parcel.replace(/-/g, '');
  if (digits.length !== 11) return parcel;
  return `${digits.substring(0, 3)}-${digits.substring(3, 9)}-${digits.substring(9, 11)}`;
}

export const authService = () => {
    return {
        logout: () => {
            localStorage.removeItem('token');
            localStorage.removeItem('parcelNumber');
            localStorage.removeItem('timeout');
        },
    };
};

export const eAlertsCoreAPIEndpoint = (endpoint) => {
  let url = eAlertsCoreAPI + endpoint + '/';

  return {
    getAll: () => axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
    getById: (id) =>
      axios.get(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    getByAccountId: (id, pageSize, currentPage, alertsDescending) => {
      let query = `?pageSize=${pageSize}&currentPage=${currentPage}&isDescending=${alertsDescending}`;
      return axios.get(url + 'Account/' + id + query, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
    },
    create: (newObject) =>
      axios.post(url, newObject, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    getByNumbers: (ids) => axios.get(url + 'getByNumbers?' + ids),
    login: (loginObject) => axios.post(url + 'login', loginObject),
    register: (newAccount) => axios.post(url + 'register', newAccount),
    verifyEmailToken: (email, token) =>
      axios.post(url + 'verify-email-token?email=' + email + '&token=' + token),
  };
};
